import ufeApi from 'services/api/ufeApi';
import localeUtils from 'utils/LanguageLocale';

function fetchTrendingContent(placement, uuid) {
    const locale = `${localeUtils.getCurrentLanguage().toLowerCase()}-${localeUtils.getCurrentCountry()}`;

    const url = `/api/content/p13n/trending/${placement}/${locale}/ufe?logoutid=${uuid}`;

    return ufeApi.makeRequest(url, { method: 'GET' }, { returnHeaders: true }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default fetchTrendingContent;
